import { render, staticRenderFns } from "./Enforce.vue?vue&type=template&id=880bd9ec&"
import script from "./Enforce.vue?vue&type=script&lang=js&"
export * from "./Enforce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports